module.exports = {"title":"Shelf Space Plan","create_shelf_space_plan":"Create New Shelf Space Plan","edit_shelf_space_plan":"Edit Shelf Space Plan","delete_shelf_space_plan":"Delete Space Plans","delete_overview":"Delete Overview","add_products":"Add Products","delete_products":"Delete Products","import":"Import","permissions":{"space_plans":{"name":"Space Plans","view":"View Space Plans","manage":"Manage Space Plans"}}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/shelf_space_plan.php
// module id = X/tz
// module chunks = 113